import React from "react";
import style from "./index.module.scss";
import { Icon } from "antd";

interface ItemStatusProps {
    status: string;
}

export default function ItemStatus({ status }: ItemStatusProps) {
    if (status === "todo") {
        return (
            <span className={style.done}>
                <Icon type="exclamation-circle" /> 未学习
            </span>
        );
    }

    return (
        <span className={style.todo}>
            <Icon type="check-circle" /> 已学习
        </span>
    );
}
